import React from "react";
import { Link } from "react-router-dom";
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import Chad from "./images/chad.png";
import "./Header.css";

const Header = (props) => {
  const [isLoggedIn, setIsLoggedIn] = React.useState(false);

  React.useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsLoggedIn(!!user);
    });
    return unsubscribe;
  }, []);

  return (
    <header style={props.style} className={props.darkMode === false ? "App-header" : "App-header-dark"}>
      <img className={props.darkMode === false ? "mainLogo" : "mainLogo-dark"} src={Chad} alt="Chad" />
      <Link className={props.darkMode === false ? "App-title neonText" : "App-title-dark neonText-dark"} to="/">
        Interview Sandbox
      </Link>
      {props.extras && <div className="extras">{props.extras}</div>}
    </header>
  );
};

export default Header;
